import React, {useContext, useEffect, useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {
    Collapse,
    IconButton,
    Button,
    InputLabel,
    MenuItem,
    FormControl,
    Select, CardHeader, Modal
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import {axiosInstance} from "../utils/axiosUtils";
import Grid from '@mui/material/Unstable_Grid2';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {ExpandMore as ExpandMoreIcon} from '@mui/icons-material';
import {ExpandLess as ExpandLessIcon} from '@mui/icons-material';
import CircularProgress from "@mui/material/CircularProgress";
import {green, blue, orange} from "@mui/material/colors";
import BusinessContext from "../contexts/BusinessContext";
import Box from "@mui/material/Box";


export default function ScheduledMessageCard({scheduledMessage, expand, phoneNumber, templates, SyncCustomer}) {
    const {testNumber, testMode} = useContext(BusinessContext);
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [expanded, setExpanded] = useState(expand);
    const [disableSendButton, setDisableSendButton] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(0);
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    useEffect(()=>{
        if (templates && templates.data && templates.data.length) {
            const template = scheduledMessage.templateName ? templates.data.find(t => t.name === scheduledMessage.templateName) : templates.data[0];
            setSelectedTemplate(template ? template.id : templates.data[0].id);
        }
    },[scheduledMessage])
    const sendMessage = async (force) => {
        setDisableSendButton(true);
        setLoader(true);
        if (force || testMode) {
            const templateName = templates.data.find((template) => template.id === selectedTemplate).name;
            const messagePhoneNumber = testMode ? testNumber : phoneNumber;
            await axiosInstance.get('/Whatsapp/SendMessage?scheduledMessageId=' + scheduledMessage.id + '&phoneNumber=' + messagePhoneNumber + ' &templateName=' + templateName);
            await SyncCustomer();
            setLoader(false);
            setDisableSendButton(false);
            if (force) {
                setShowModal(false);
            }
        } else {
            setShowModal(true);
        }
    }
    const deleteTestMessage = async () => {
        setLoader(true);
        await axiosInstance.delete('/Whatsapp/?scheduledMessageId=' + scheduledMessage.id);
        await SyncCustomer();
        setLoader(false);
    }
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const renderReplyValue = (messagesReply) => {
        return messagesReply.map((messageReply, index) => {
            switch (messageReply.type) {
                case "button":
                    return (
                        <ListItem sx={{paddingTop: 0, paddingBottom: 0}} id={index}>
                            <ListItemAvatar>
                                <Avatar>
                                    <BeachAccessIcon/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={messageReply.value} secondary={"כפתור"}/>
                        </ListItem>
                    );
                default:
                    return messageReply.value;
            }
        });
    }
    const renderTemplatesDropDown = () => {
        if (templates && templates.data){
            return templates.data.map((template, index) => (
                <MenuItem id={index} value={template.id}>{template.name}</MenuItem>));
        }
        return null;
    }
    const getMessageTitle = (type, isActionLogTestMode) => {
        const testPrefix = isActionLogTestMode ? " - בדיקה" : "";
        if (type==='automation') {
            return "הודעה מתוזמנת" + testPrefix;
        }
        return "פרסומת לקטגוריה" + testPrefix
    }
    const messagesSent = scheduledMessage.actionLogs.filter((actionLog) => actionLog.type === "message" && actionLog.action === "accepted");
    const isActionLogTestMode = !!messagesSent.length && messagesSent.every((m) => m.isTest);
    /*const messageTitle = isActionLogTestMode ? "הודעה מתוזמנת - בדיקה" : "הודעה מתוזמנת";*/
    const messageTitle = getMessageTitle(scheduledMessage.type, isActionLogTestMode);
    const isScheduledMessageTestMode = !!scheduledMessage.isTest;
    const secondMessageTitle = isScheduledMessageTestMode ? "תזכורת - בדיקה" : "תזכורת";
    const messageReceived = scheduledMessage.actionLogs.find((actionLog) => actionLog.action === "delivered");
    const messageRead = scheduledMessage.actionLogs.find((actionLog) => actionLog.action === "read");
    return (
        <Card raised sx={{width: 380, marginTop: '10px'}}>
            <CardHeader
                action={(isActionLogTestMode || isScheduledMessageTestMode) ?
                    <IconButton aria-label="settings">
                        <DeleteIcon onClick={deleteTestMessage}/>
                    </IconButton> : null
                }
                sx={{bgcolor: scheduledMessage.type !== 'automation' ? orange[500] : scheduledMessage.contextId ? green[500] : blue[500]}}
                title={scheduledMessage.contextId ? secondMessageTitle : messageTitle}
            />
            <CardContent>
                <Grid container spacing={1}>
                    <Grid>
                        <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                            {!messagesSent.length && <ListItem sx={{float: "left"}}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">טמפלייט</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedTemplate}
                                        label="טמפלייט"
                                        onChange={(e) => setSelectedTemplate(e.target.value)}
                                    >
                                        {renderTemplatesDropDown()}
                                    </Select>
                                </FormControl>
                            </ListItem>}
                            {!messagesSent.length && <ListItem>
                                <Button disabled={disableSendButton} onClick={() => sendMessage(false)}
                                        variant="outlined">
                                    {loader ? <CircularProgress size={25}/> : "שלח"}
                                </Button>
                            </ListItem>}
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <BeachAccessIcon/>
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary="מוצר" secondary={<a target="_blank"
                                                                           href={scheduledMessage.productUrl}>{scheduledMessage.productName}</a>}/>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <BeachAccessIcon/>
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary="תאריך לשליחת הודעה"
                                              secondary={new Date(scheduledMessage.scheduledMessageDateBy3LastOrders).toLocaleDateString('en-GB')}/>
                            </ListItem>
                        </List>
                    </Grid>
                    {messagesSent.map((messageSent) => {
                        const messagesReply = scheduledMessage.actionLogs.filter((actionLog) => messageSent.messageId === actionLog.contextId && actionLog.action === "reply");
                        return (
                            <Grid container spacing={1}>
                                <Grid container>
                                    <Grid container item>
                                        <FormControlLabel xs={12} control={<Switch checked={!!messageSent}/>}
                                                          label={"נשלח - " + messageSent.value.replace("templateName:", "").trim()}/>
                                    </Grid>
                                    <Grid container item>
                                        <ListItemText xs={12}
                                                      primary={"בתאריך:" + new Date(messageSent.created).toLocaleDateString('en-GB')}/>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel xs={12} control={<Switch checked={!!messageReceived}/>}
                                                      label="הגיע"/>
                                    <FormControlLabel xs={12} control={<Switch checked={!!messageRead}/>} label="נצפה"/>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel xs={12}
                                                      control={<Switch
                                                          checked={messagesReply && messagesReply.length}/>}
                                                      label="הגיב"/>
                                </Grid>
                                <Grid item xs={12}>
                                    {!!messagesReply && renderReplyValue(messagesReply)}
                                </Grid>
                            </Grid>
                        )
                    })}

                    <Grid>
                        {expanded ? <IconButton
                                aria-expanded={expanded}
                                aria-label="show more"
                                onClick={handleExpandClick}
                            >
                                <ExpandMoreIcon/>
                            </IconButton> :
                            <IconButton
                                aria-expanded={expanded}
                                aria-label="show more"
                                onClick={handleExpandClick}
                            >
                                <ExpandLessIcon/>
                            </IconButton>}
                    </Grid>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Grid xs={12} marginTop={"20px"}>
                            <Typography variant="body" color="text.secondary">
                                <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <WorkIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary="תאריך ההזמנה האחרונה"
                                                      secondary={new Date(scheduledMessage.lastOrderDate).toLocaleDateString('en-GB')}/>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <WorkIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary="תאריך ההזמנה הבאה"
                                                      secondary={new Date(scheduledMessage.nextExpectedPurchase).toLocaleDateString('en-GB')}/>
                                    </ListItem>
                                </List>
                            </Typography>
                        </Grid>
                    </Collapse>
                </Grid>
            </CardContent>
            <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        שים לב!
                    </Typography>
                    <Typography id="modal-modal-description" sx={{mt: 2}}>
                        אתה הולך לשלוח הודעה למספר {phoneNumber}, האם אתה בטוח?
                    </Typography>
                    <Button onClick={() => sendMessage(true)}>לאישור</Button>
                </Box>
            </Modal>
        </Card>
    );
}
